import React from 'react';
import { Spin } from 'antd';

export default function withSpin(Wrapee) {
	return class extends React.Component {
		state = {
			loading: false,
			submitting: false,
			submitted: false
		}
		handleLoading = () => this.setState({ loading: true })
		handleDone = () => this.setState({ loading: false })
		handleSubmitting = () => this.setState({ submitting: true })
		handleSubmitted = () => this.setState({ submitting: false, submitted: true });
		getStatus = () => this.state;
		render() {
			return (
				<Spin spinning={this.state.loading ||
				(typeof this.props.folio !== 'undefined' && !this.props.folioLoaded && !this.props.folioError)}>
					<Wrapee
						isLoading={this.handleLoading}
						isDoneLoading={this.handleDone}
						isSubmitting={this.handleSubmitting}
						isSubmitted={this.handleSubmitted}
						getStatus={this.getStatus}
						{... this.props} />
				</Spin>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/withSpin/index.jsx